import { render, staticRenderFns } from "./colHeight-editor.vue?vue&type=template&id=97a1be7a&scoped=true"
import script from "./colHeight-editor.vue?vue&type=script&lang=js"
export * from "./colHeight-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1be7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97a1be7a')) {
      api.createRecord('97a1be7a', component.options)
    } else {
      api.reload('97a1be7a', component.options)
    }
    module.hot.accept("./colHeight-editor.vue?vue&type=template&id=97a1be7a&scoped=true", function () {
      api.rerender('97a1be7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-grid/colHeight-editor.vue"
export default component.exports